import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { timeout } from 'rxjs';

export const TIMEOUT_DURATION = new HttpContextToken<number>(() => 30000);
export const TIMEOUT_ENABLED = new HttpContextToken<boolean>(() => true);

export const timeoutInterceptor: HttpInterceptorFn = (req, next) => {
	const timeoutDuration = req.context.get(TIMEOUT_DURATION);
	const timeoutEnabled = req.context.get(TIMEOUT_ENABLED);

	if (timeoutEnabled) return next(req).pipe(timeout(timeoutDuration));

	return next(req);
};
